import { render, staticRenderFns } from "./ScratchDialog.vue?vue&type=template&id=054bd6fe&scoped=true"
import script from "./ScratchDialog.vue?vue&type=script&lang=js"
export * from "./ScratchDialog.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=054bd6fe&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054bd6fe",
  null
  
)

export default component.exports